/**
 * 智能合约方法
 */

import { readContract, writeContract } from "@wagmi/core"
import { contractABI, contractAddress } from "./publicValue"
import { parseEther } from 'viem'

export const isInWhitelist = async (config, walletAddress) => {
    return await readContract(config, {
        abi: contractABI,
        address: contractAddress,
        args: [walletAddress],
        functionName: "isWhitelisted",
        account: walletAddress
    })
}

export const mintEnabled = async (config) => {
    return await readContract(config, {
        abi: contractABI,
        address: contractAddress,
        functionName: "mintEnabled",
    })
}

export const safeMint = async (config, walletAddress ) => {
    let result = await writeContract(config, {
        abi: contractABI,
        address: contractAddress,
        args: [walletAddress],
        functionName: "safeMint",
        value: parseEther('0.18312'), 
    })
    return result
}